// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"98117677","488":"a38c3503"}[chunkId] + ".chunk.js";
};